import styled, { css } from 'styled-components';
import {
    Flex,
    Heading,
    IconStar,
    Label,
    Paragraph,
    Spacer,
    StyledLabel,
    Text,
    VisuallyHidden,
    mediaMixin,
    spaceMixin,
    token,
} from '@zillow/constellation';
import PropTypes from 'prop-types';
const REVIEWS = [
    {
        title: 'Like talking to a family member',
        rating: 5,
        description:
            "Mitch has taken so much time to answer all my questions in detail. His knowledge and advice have exceeded anyone I've ever consulted about buying a home. I can't say enough about how impressed I've been with how much time he spent guiding me through all my options on specific loans to making an offer on a home.",
        name: 'Pamela',
        location: 'Anderson, SC',
    },
    {
        title: 'Friendly and quick',
        rating: 4,
        description:
            'Very friendly and timely. They worked with me to get all the documentation that I needed. Having never been through this process before, they were very helpful and patient.',
        name: 'Sydny',
        location: 'Sheboygan Falls, WI',
    },
    {
        title: 'Fast and driven',
        rating: 5,
        description:
            "We needed to close in 16 days due to outside factors we couldn't control. I don't know how they did it, but we closed on time, keeping us from living out of a hotel. It felt as though we were VIP applicants. They came through for us big time.",
        name: 'David',
        location: 'Mansfield, OH',
    },
];
const StyledReview = styled.div`
    display: flex;
    flex-direction: column;
    padding: 0 ${spaceMixin('md')};
    flex: 1 1 0;
`;
const StyledName = styled(Label)`
    margin-top: ${spaceMixin('sm')};
`;
const StyledStarSVG = styled(IconStar).attrs({ size: 'sm' })`
    fill: ${token('colors.gray500')};
    & + & {
        margin-left: ${spaceMixin('xs')};
    }
`;
const getReviewStars = rating => {
    const ratingStars = [];
    for (let i = 0; i < rating; i++) {
        ratingStars.push(<StyledStarSVG key={i} />);
    }
    return ratingStars;
};
const Review = ({ title, rating, description, name, location }) => (
    <StyledReview>
        <Heading level="6">{title}</Heading>
        <Spacer marginTop="xs" marginBottom="xs">
            <Flex display="flex">
                <VisuallyHidden>{rating} out of 5 stars</VisuallyHidden>
                {getReviewStars(rating)}
            </Flex>
        </Spacer>
        <Paragraph>{description}</Paragraph>
        <StyledName>{name}</StyledName>
        <Text>{location}</Text>
    </StyledReview>
);
Review.propTypes = {
    title: PropTypes.string,
    rating: PropTypes.number,
    description: PropTypes.string,
    name: PropTypes.string,
    location: PropTypes.string,
};
const StyledHeader = styled(Heading)`
    text-align: center;
    margin-bottom: ${spaceMixin('md')};
    ${mediaMixin(
        'md',
        css`
            padding-top: ${spaceMixin('xl')};
        `
    )}
`;
const StyledReviewPreview = styled.div`
    width: 100%;
    ${StyledLabel}:hover {
        cursor: default;
    }
    ${StyledReview} {
        flex: 1 1 auto;
        ${mediaMixin(
            'lg',
            css`
                flex-basis: 0;
            `
        )}
        + ${StyledReview} {
            margin-top: ${spaceMixin('lg')};
        }
    }
    ${mediaMixin(
        'lg',
        css`
            & > ${Flex} {
                flex-direction: row;
            }
            ${StyledReview} + ${StyledReview} {
                margin-top: 0;
            }
            padding: 0 ${spaceMixin('sm')};
            margin-right: ${spaceMixin('lg')};
            margin-left: ${spaceMixin('lg')};
        `
    )}
`;
const ReviewPreview = ({ className }) => (
    <StyledReviewPreview className={className}>
        <StyledHeader level="3" serif>
            What our customers say
        </StyledHeader>
        <Flex display="flex" flexDirection="column">
            {REVIEWS.map(review => (
                <Review {...review} key={review.name} />
            ))}
        </Flex>
    </StyledReviewPreview>
);
ReviewPreview.propTypes = {
    className: PropTypes.string,
};

export default ReviewPreview;
